export default __webpack_public_path__ + "static/media/eyesight.1ad0254e.svg";